import { t } from '@transifex/native';
import * as yup from 'yup';
import { editCreateEnvironment } from '../core/messages/en';
import { ENVIRONMENT_NAME_VALIDATION_PATTERN } from '../utils/constants';
import { TenantType } from '../types';

const {
	nameValidation1,
	nameValidation3,
	nameValidation4,
	needToContinue,
	tenantTypeValidation3,
	tenantTypeValidation4,
} = editCreateEnvironment;

export const editCreateEnvironmentSchema = (
	allEnvironmentsLimitation: any,
	isEdit: boolean,
) =>
	yup.object({
		name: yup
			.string()
			.required(t(nameValidation1))
			.max(100, t(nameValidation3))
			.matches(
				new RegExp(ENVIRONMENT_NAME_VALIDATION_PATTERN),
				nameValidation4,
			),
		deployOnCommit: yup.string().required(t(needToContinue)),
		tenantType: isEdit
			? yup.string().notRequired()
			: yup
					.string()
					.required(t(needToContinue))
					.test(
						'all-environment-limit-validation',
						'All environment tier validation failed',
						function (value) {
							const { path, createError } = this;

							if (
								value === TenantType.Production.toString() &&
								allEnvironmentsLimitation?.data
									?.isProdLimitExceeds
							) {
								return createError({
									path,
									message: t(tenantTypeValidation3),
								});
							} else if (
								value === TenantType.NonProduction.toString() &&
								allEnvironmentsLimitation?.data
									?.isNonProdLimitExceeds
							) {
								return createError({
									path,
									message: t(tenantTypeValidation4),
								});
							}
							return true;
						},
					),
	});
